module.exports = __webpack_public_path__ + "img/1482135554614.7ebd1f68.jpg";